import { Link } from "react-router-dom";

/**
 * Case à cocher obligatoire d'acceptation des CGV + Politique de confidentialité.
 * Affichée pour TOUT LE MONDE (utilisateurs connectés ET invités) avant toute
 * action engageante (achat, don, réservation, réclamation de bon...).
 */
export default function TermsConsent({ checked, onChange, testId = "terms-consent" }) {
  return (
    <label
      style={{
        display: "flex", alignItems: "flex-start", gap: 10,
        fontSize: 13, color: "var(--z-muted,#5B6671)", lineHeight: 1.5,
        margin: "4px 0 14px", cursor: "pointer",
      }}
      data-testid={testId}
    >
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        data-testid={`${testId}-checkbox`}
        style={{ marginTop: 2, width: 17, height: 17, flexShrink: 0, accentColor: "var(--z-teal,#01696F)" }}
      />
      <span>
        J'ai lu et j'accepte les{" "}
        <Link to="/cgv" target="_blank" className="z-link" data-testid={`${testId}-cgv-link`}>
          Conditions Générales
        </Link>{" "}
        et la{" "}
        <Link to="/confidentialite" target="_blank" className="z-link" data-testid={`${testId}-privacy-link`}>
          Politique de confidentialité
        </Link>.
      </span>
    </label>
  );
}
